// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1R4WQ","toggleWrap":"styles_toggleWrap__1_tdZ","content":"styles_content__3oLnL","selectAreaCode":"styles_selectAreaCode__2LnmW"};